import type { SFC } from 'react';

import { LicenseTerm } from '../../types';
import { Pill } from '../generic/Pill';

const LicenseTermPill : SFC<{
  term: LicenseTerm,
}> = ({
  term,
}) => {
  let color;
  switch (term.role) {
    case 'CAN':
      color = 'green';
      break;
    case 'CANNOT':
      color = 'red';
      break;
    case 'MUST':
      color = 'blue';
      break;
  }

  return (
    <Pill style={{ display: 'inline-block', margin: '3px' }} color={color}>{term.termId}</Pill>
  );
};

export default LicenseTermPill;
